import React, { ReactNode, useEffect, useRef, useState } from "react";
import { _TopBarRoot } from "./TopBar.styled";

export interface ITopBarProps {
  visible?: boolean;
  bg?: string;
  children: ReactNode;
  style?: React.CSSProperties;
  onHeightChange?: (height: number) => void;
}

const TopBar = (props: ITopBarProps) => {
  const { children, style, onHeightChange, ...rest } = props;

  const elementRef = useRef<HTMLParagraphElement>(null);
  const [elementHeight, setElementHeight] = useState(46);
  useEffect(() => {
    if (elementRef.current) {
      const _element = elementRef.current;
      const observer = new ResizeObserver((entries) => {
        for (let entry of entries) {
          setElementHeight(entry.contentRect.height);
          onHeightChange && onHeightChange(entry.contentRect.height);
        }
      });
      setTimeout(() => {
        observer.observe(_element);
      }, 1000);
      return () => {
        if (_element) {
          observer.unobserve(_element);
        }
      };
    }
  }, []);

  return (
    <_TopBarRoot
      style={style}
      ref={elementRef}
      $height={elementHeight}
      {...rest}
    >
      {children}
    </_TopBarRoot>
  );
};

export default TopBar;
